module.exports = __webpack_public_path__ + "img/logo.35bf8efe.svg";